import React from 'react';

import { Title, ButtonsGroup, Button, Input } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import { aboutCompanySchema } from 'validation-schemas/direto';
import { getObjectAsList } from 'utils/utils';
import { BorrowerRelationship } from 'enums/enums';
import AtomicDropdown from 'components/AtomicDropdown';
import { Borrower } from 'generated/graphql';
import { getFieldOrder } from 'configs/routes';
import Paragraph from 'components/commons/paragraph';
import useOptimizeConfig from 'components/optimize/optimize-hook';
import { IStepInfo } from 'providers/profile.config';

type AboutCompanyProps = {
    initialValue: Borrower;
    stepInfo: IStepInfo;
    screenProfile: 'default' | 'partners';
    onSubmit(borrower: Borrower): void;
    onBack(): void;
};

const AboutCompany: React.FC<AboutCompanyProps> = ({
    initialValue,
    stepInfo: { title },
    screenProfile,
    onSubmit,
    onBack,
}) => {
    const { componentVisibility } = useOptimizeConfig();

    const components = getFieldOrder(
        [
            {
                id: 'companyDocument',
                render: (key: number) => (
                    <Field
                        component={Input}
                        placeholder="CNPJ"
                        name="companyDocument"
                        mask="cnpj"
                        info="CNPJ precisa estar ativo por mais de 1 ano"
                        key={key}
                        id="company_id"
                    />
                ),
            },
            {
                id: 'monthlyRevenue',
                render: (key: number) => (
                    <Field
                        component={Input}
                        placeholder="Faturamento Mensal"
                        name="monthlyRevenue"
                        mask="money"
                        prefix="R$ "
                        sufix=" por mês"
                        info="Mínimo de R$10.000 por mês. O faturamento precisará ser comprovado."
                        decimalScale={0}
                        key={key}
                        id="company_monthly_revenue"
                    />
                ),
            },
            {
                id: 'relationship',
                render: (key: number) => (
                    <div className="field-group half mt-2 mb-5" key={key}>
                        <label>
                                {screenProfile === 'partners' ?
                                    'Qual a relação do seu cliente com a empresa?' :
                                    'Qual a sua relação com a empresa?'
                                }
                        </label>
                        <Field
                            component={AtomicDropdown}
                            options={getObjectAsList(BorrowerRelationship)}
                            name="relationship"
                            id="company_user_relation"
                        />
                    </div>
                ),
            },
        ],
        'AboutCompany'
    );

    return (
        <div className="screen about-company-screen">
            <Form
                schema={aboutCompanySchema}
                initialValues={initialValue}
                onSubmit={onSubmit}
                render={({ valid }) => (
                    <>
                        <Title>
                            <span dangerouslySetInnerHTML={{ __html: title }} />
                        </Title>

                        {componentVisibility.aboutCompanyAdvice && (
                            <Paragraph className="m-0 mt-3">
                                Fique tranquilo, seus dados não serão
                                compartilhados,{' '}
                                <br className="d-none d-sm-block" />
                                usaremos somente para análise de crédito.
                            </Paragraph>
                        )}

                        {components.map((comp, key) => comp.render(key))}

                        <ButtonsGroup>
                            <Button
                                label="voltar"
                                variant="secondary"
                                onClick={onBack}
                                data-category="Navegação Direto"
                                data-action="Clique Voltar"
                                data-label="Voltar /pedido/sobre-a-empresa"
                            />
                            <Button
                                label="continuar"
                                disabled={!valid}
                                type="submit"
                            />
                        </ButtonsGroup>
                    </>
                )}
            />
        </div>
    );
};

export default AboutCompany;
